import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

function HierarchyIcon(props) {
    return (
        <SvgIcon {...props}>
            <g id="Group_201" data-name="Group 201" transform="translate(-15045 49)">
                <g id="Group_200" data-name="Group 200" transform="translate(19 -9)">
                    <rect id="Rectangle_980" data-name="Rectangle 980" width="16" height="2" transform="translate(15030 -34)" fill="#13294b" />
                    <rect id="Rectangle_981" data-name="Rectangle 981" width="14" height="2" transform="translate(15032 -29)" fill="#13294b" />
                    <rect id="Rectangle_982" data-name="Rectangle 982" width="11" height="2" transform="translate(15035 -24)" fill="#13294b" />
                </g>
                <path id="Path_1432" data-name="Path 1432" d="M0,0H24V24H0Z" transform="translate(15045 -49)" fill="none" />
                <path id="Path_1434" data-name="Path 1434" d="M0,0H24V24H0Z" transform="translate(15045 -49)" fill="none" />
            </g>
        </SvgIcon>
    );
}

export default HierarchyIcon;